import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import { CustomIconButton } from '../../../layout/styledcomponents/CustomIconButton';
import DropdownFilter from '../../../layout/styledcomponents/filters/Dropdown';

import {
    openFilterClientAction,
    selectFilteredClientData,
} from '../../../app/Slices/ClientFilterSlice';

export default function ClientsHero() {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const filterResults: any = useSelector(selectFilteredClientData);
    const [status, setStatus] = useState(filterResults?.status || 'All');

    const theme = useTheme();

    const handleAddClick = () => {
        navigate(`/newClient`);
    };

    const handleStatus = (value: any) => {
        setStatus(value);
        dispatch(
            openFilterClientAction({
                filteredData: {
                    status: value,
                    // role: role,
                },
            }),
        );
    };
    return (
        <>
            <Grid
                sx={{
                    textAlign: ' right',
                    paddingBottom: isMobile ? '10px' : '0px',
                }}
            >
                {isMobile ? (
                    <CustomIconButton
                        variant='contained'
                        color='primary'
                        onClick={handleAddClick}
                        sx={{
                            '&:hover': {
                                cursor: 'pointer',
                                color: theme.palette.textAccent.main,
                                backgroundColor: 'transparent',
                                background: 'none',
                            },
                        }}
                    >
                        <AddCircleIcon />
                    </CustomIconButton>
                ) : (
                    <CustomButton
                        variant='contained'
                        color='primary'
                        startIcon={<AddCircleIcon />}
                        onClick={handleAddClick}
                    >
                        Add New Host
                    </CustomButton>
                )}
            </Grid>
            <Grid
                sx={{
                    width: '100%',
                    minHeight: 'auto',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}
            >
                <Grid
                    sx={{
                        width: isMobile ? '100%' : '25%',
                        // backgroundColor: 'blue',
                        marginRight: isMobile ? '0px' : '30px',
                    }}
                >
                    <DropdownFilter
                        id={'statusFilter'}
                        options={[
                            { value: 'All', label: 'All' },
                            { value: 'enabled', label: 'Enabled' },
                            { value: 'disabled', label: 'Disabled' },
                        ]}
                        handleChange={handleStatus}
                        selectedValue={
                            <Grid
                                sx={{ display: 'flex', flexDirection: 'row' }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: '16px',
                                        marginRight: '5px',
                                    }}
                                >
                                    Status:
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: '16px',
                                    }}
                                >
                                    {status}
                                </Typography>
                            </Grid>
                        }
                        backgroundColor={theme.palette.neutral.main}
                        border={theme.palette.midGrey.main}
                    />
                </Grid>
            </Grid>
        </>
    );
}
